import script from "./OtaUpgrade.vue?vue&type=script&setup=true&lang=ts"
export * from "./OtaUpgrade.vue?vue&type=script&setup=true&lang=ts"

import "./OtaUpgrade.vue?vue&type=style&index=0&id=50bd4278&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50bd4278"]])

export default __exports__